/**
 * Clamp a requested page only when the response belongs to that exact request.
 * This prevents stale/empty loading data from bouncing pagination back to page 1.
 */
export function clampPageAfterResponse(
    requestedPage: number,
    totalPages: number,
    responsePage?: number
): number {
    if (responsePage !== requestedPage) return requestedPage;
    return requestedPage > totalPages ? totalPages : requestedPage;
}
